// extracted by mini-css-extract-plugin
module.exports =  {"root":"bJb47x6h3iQYFCRVMShR"};